import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { colors } from '../theme';
import { productsData } from '../data/productsData';
import ProductBlock from './ProductBlock';
import { fadeInUp, staggerContainer } from '../utils/animations';

/**
 * HEURÍSTICAS APLICADAS NA PRODUCTS SECTION:
 *
 * #1 - Visibilidade do status do sistema:
 *   - Animações progressivas mostram carregamento do conteúdo
 *
 * #4 - Consistência e padrões:
 *   - Layout e animações consistentes
 *
 * #8 - Design estético e minimalista:
 *   - Espaçamento adequado entre produtos
 *   - Animações elegantes sem distrações
 */

const ProductsSection: React.FC = () => {
  return (
    <Box
      id="produtos"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: colors.beige,
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={fadeInUp}
        >
          <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 10 } }}>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                color: colors.blackMatte,
                mb: 2,
                fontWeight: 700,
              }}
            >
              Nossos Produtos
            </Typography>

            <motion.div
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.6,
                delay: 0.2,
                ease: [0.43, 0.13, 0.23, 0.96],
              }}
            >
              <Box
                sx={{
                  width: '80px',
                  height: '3px',
                  backgroundColor: colors.agedGold,
                  mx: 'auto',
                  mb: 3,
                }}
              />
            </motion.div>

            <Typography
              variant="h6"
              sx={{
                color: colors.blackMatte,
                maxWidth: '700px',
                mx: 'auto',
                opacity: 0.9,
                fontWeight: 400,
              }}
            >
              Linha completa de cuidados profissionais para barba.
              <br />
              Qualidade que você sente, resultados que você vê.
            </Typography>
          </Box>
        </motion.div>

        {productsData.map((product, index) => (
          <ProductBlock key={product.id} product={product} index={index} />
        ))}
      </Container>
    </Box>
  );
};

export default ProductsSection;
